import { EMOJI } from "./constants.js";
/**
 * Tahmini cevaba göre renklendirir.
 *
 * İki geçişli algoritma — tekrarlı harflerin doğru işlenmesi için şart:
 *   1. Önce tam yerinde olanlar `correct` işaretlenir ve cevaptaki o harfler
 *      "tüketilir".
 *   2. Kalan harfler için: harf, cevabın tüketilmemiş harfleri arasında varsa
 *      `present`, yoksa `absent`.
 *
 * Örnek: cevap "KAPAK", tahmin "AAAAA" -> ilk iki A yerinde değil ama cevapta
 * 2 adet A var; algoritma yalnızca 2 tanesini sarı/yeşil yapar.
 *
 * Girdiler normalize edilmiş (Türkçe büyük harf) ve aynı uzunlukta olmalıdır.
 */
export function evaluateGuess(guess, answer) {
    const g = [...guess];
    const a = [...answer];
    if (g.length !== a.length) {
        throw new Error(`Guess and answer lengths differ: "${guess}" (${g.length}) vs "${answer}" (${a.length})`);
    }
    const result = new Array(g.length).fill("absent");
    const remaining = new Map();
    // 1. geçiş — tam eşleşmeler
    for (let i = 0; i < g.length; i++) {
        if (g[i] === a[i]) {
            result[i] = "correct";
        }
        else {
            remaining.set(a[i], (remaining.get(a[i]) ?? 0) + 1);
        }
    }
    // 2. geçiş — yanlış yerdeki harfler, kalan havuzdan düşülerek
    for (let i = 0; i < g.length; i++) {
        if (result[i] === "correct")
            continue;
        const left = remaining.get(g[i]) ?? 0;
        if (left > 0) {
            result[i] = "present";
            remaining.set(g[i], left - 1);
        }
    }
    return result;
}
/** Tahmin tamamen doğru mu? */
export function isSolved(pattern) {
    return pattern.length > 0 && pattern.every((s) => s === "correct");
}
const PRIORITY = {
    absent: 0,
    present: 1,
    correct: 2,
};
/**
 * Klavye harf renklerini günceller. Bir harf bir kez yeşil olduysa
 * sonraki tahminlerde sarıya/griye düşmez.
 */
export function mergeKeyboardStates(previous, guess, pattern) {
    const next = { ...previous };
    const letters = [...guess];
    for (let i = 0; i < letters.length; i++) {
        const letter = letters[i];
        const state = pattern[i];
        const current = next[letter];
        if (current === undefined || PRIORITY[state] > PRIORITY[current]) {
            next[letter] = state;
        }
    }
    return next;
}
/** Tek satırın emoji karşılığı — sonuç paylaşımı için. */
export function patternToEmoji(pattern) {
    return pattern.map((s) => EMOJI[s]).join("");
}
/** Tüm tahtanın emoji dökümü. */
export function boardToEmoji(patterns) {
    return patterns.map(patternToEmoji).join("\n");
}
//# sourceMappingURL=scoring.js.map